import { z } from 'zod';

/**
 * Stabile Fehlercodes. Der Server sendet ausschließlich Codes, die deutsche
 * Anzeige liegt im Client — so bleibt das Protokoll sprachunabhängig.
 */
export const ErrorCodeSchema = z.enum([
  // Transport / Protokoll
  'BAD_MESSAGE',
  'RATE_LIMITED',
  'PROTOCOL_MISMATCH',
  'SERVER_LIMIT',

  // Raum
  'ROOM_NOT_FOUND',
  'ROOM_FULL',
  'ROOM_LOCKED',
  'GAME_RUNNING',
  'ALREADY_IN_ROOM',
  'NOT_IN_ROOM',

  // Name
  'INVALID_NAME',
  'NAME_TAKEN',

  // Host / Einstellungen
  'NOT_HOST',
  'NOT_ENOUGH_PLAYERS',
  'INVALID_MAFIA_COUNT',
  'TOO_MANY_SPECIAL_ROLES',
  'INVALID_SETTINGS',
  'CANNOT_KICK_SELF',
  'PLAYER_NOT_FOUND',

  // Wiedereinstieg ohne Token
  /** Der angefragte Platz ist gerade verbunden — es gibt nichts zurückzufordern. */
  'SEAT_ACTIVE',
  /** Der Absender darf diese Anfrage nicht bestätigen. */
  'REJOIN_NOT_ALLOWED',
  'REQUEST_NOT_FOUND',
  'TOO_MANY_REQUESTS',

  // Ablauf / Abstimmung
  'WRONG_PHASE',
  'NOT_ALIVE',
  'ALREADY_VOTED',
  'INVALID_TARGET',
  'SELF_VOTE',
  'ABSTAIN_DISABLED',

  // Sonderrollen
  /** Keine Sonderrolle, Ladung verbraucht, oder falscher Lebendstatus. */
  'ABILITY_UNAVAILABLE',
  /** Getrennt von `INVALID_TARGET`, damit der Client fähigkeitsspezifisch antworten kann. */
  'INVALID_ABILITY_TARGET',
]);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;
